export default __webpack_public_path__ + "media/images/blog/blog-04-770x520-e00656c98b8bed591bbe72c0d7c38513.jpg";